import React, { useEffect } from 'react';

export default function RedirectToHome(props) {

	useEffect(() => {
		window.location.href = "/mock-test";
	}, []);

	return "";
}